import styled from "styled-components";
import { type SpaceProps, space } from "styled-system";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import * as Flex from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import * as List from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/List";
import * as FinanceListStyle from "../../../../../../../../common-deprecated/styles/v2/toyota/custom/FinanceList";
import * as PaymentDetailsStyles from "../../../common/styles/PaymentDetails";

export const Wrapper = styled.div<{ hasBackground?: boolean } & SpaceProps>`
    margin-top: ${theme.space[3]}px;
    padding: ${theme.space[3]}px 0;
    background-color: ${({ hasBackground }) => (hasBackground ? theme.colors.grey1 : "transparent")};

    @media ${getBreakpoint("up", "md")} {
        padding: 75px 50px;
    }

    @media ${getBreakpoint("up", "lg")} {
        margin-top: ${theme.space[5]}px;
        padding: ${theme.space[6]}px 0;
    }

    ${FinanceListStyle.Header} {
        font-size: 1.6rem;
    }
    ${FinanceListStyle.Content} {
        dd,
        dt {
            font-size: 1.6rem;
        }
    }

    ${PaymentDetailsStyles.Wrapper} {
        margin-top: ${theme.space[3]}px;
        dt {
            font-family: ${theme.fonts.base};
        }
        dd {
            font-family: ${theme.fonts.regular};
        }
        dt,
        dd {
            margin-bottom: 0;
            padding: ${theme.space[2]}px 0;
            border-top: 1px solid ${theme.colors.grey2};
        }
    }

    /* Specific styling for list item */
    ${List.BulletListItem} {
        margin-bottom: ${theme.space[3]}px;
        span {
            font-family: ${theme.fonts.base};
            font-size: 1.6rem;
            line-height: 2.4rem;
            color: ${theme.colors.primaryBlack};

            strong {
                font-family: ${theme.fonts.regular};
            }
        }
    }

    ${space};
`;

export const Sidebar = styled(Flex.Col)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media ${getBreakpoint("only", "md")} {
        position: relative;
        &::before,
        &::after {
            display: block;
            position: relative;
            width: 160px; /* magic value */
            height: 100%;
            content: "";
            background-color: ${theme.colors.primaryWhite};
        }

        &::before {
            left: -130px; /* magic value */
        }

        &::after {
            right: -130px; /* magic value */
        }
    }

    @media ${getBreakpoint("up", "lg")} {
        justify-content: flex-end;
        background-color: transparent;
    }
`;

export const Panel = styled.div`
    width: 100%;
    margin-top: ${theme.space[6]}px;
    padding: ${theme.space[5]}px;
    padding-top: 0;
    background-color: ${theme.colors.primaryWhite};

    @media ${getBreakpoint("up", "lg")} {
        width: 458px;
        margin-top: 0;
        padding: ${theme.space[5]}px;
    }
`;

export const ImageWrapper = styled.div`
    max-width: 320px;
    margin-bottom: 46px;

    @media ${getBreakpoint("up", "md")} {
        max-width: none;
    }
`;

export const Title = styled.h1.attrs(() => ({
    className: "t-beta-text",
}))`
    margin-bottom: ${theme.space[3]}px;
    font-family: ${theme.fonts.base};
    text-transform: none;

    @media ${getBreakpoint("down", "md")} {
        margin-bottom: ${theme.space[2]}px;
        font-family: ${theme.fonts.regular};
        font-size: 2.2rem;
        line-height: 2.8rem;
    }
`;

export const BasketTitle = styled.h2.attrs(() => ({
    className: "t-gamma-text",
}))`
    margin-bottom: ${theme.space[1]}px;

    span {
        padding-left: ${theme.space[1]}px;
        color: ${theme.colors.grey3};
    }

    html[dir="rtl"] & {
        span {
            padding-right: ${theme.space[1]}px;
        }
    }
`;

export const Details = styled.div.attrs(() => ({
    className: "t-base",
}))`
    font-family: ${theme.fonts.base};
    color: ${theme.colors.grey7};
`;

export const Description = styled.p.attrs(() => ({
    className: "t-base",
}))`
    margin-bottom: ${theme.space[5]}px;
    font-family: ${theme.fonts.base};
    color: ${theme.colors.primaryBlack};
`;
